import React from "react";
import { User, Activity } from "lucide-react";
import { FormSelect } from "../../../../components/ui";

export const StatusAssignmentPanel = ({
  lead,
  stages,
  isAssignedToPM,
  isSalesExec,
  isSalesHead,
  isSuperAdmin,
  onStatusChange,
}) => {
  const isStatusLocked = false;
  const canChangeStatus = isSalesExec || isSalesHead || isSuperAdmin;

  // Filtering logic: only for Sales Executives
  const currentIndex = stages.findIndex(s => s.key === lead.leadStatus);
  const filteredStages = stages.filter((s, index) => {
    if (!isSalesExec) return true;

    // 1. Hide 'new' if already assigned or beyond
    if (currentIndex >= 1 && s.key === 'new') return false;

    // 2. Hide 'assigned' if already contacted or beyond
    if (currentIndex >= 2 && s.key === 'assigned') return false;

    return true;
  });

  return (
    <div className="flex flex-col gap-5">
      {/* Status Selection */}
      {/* Status Selection - Hidden as requested */}
      {/* <FormSelect
        label="Update Lead Status"
        icon={<Activity size={12} className="text-slate-400" />}
        value={lead.leadStatus}
        onChange={e => onStatusChange(e.target.value)}
        disabled={isStatusLocked || !canChangeStatus}
        options={filteredStages.map(s => ({ value: s.key, label: s.label }))}
        inputClassName={`font-bold text-brand-dark ${isStatusLocked || !canChangeStatus ? "opacity-60 cursor-not-allowed bg-slate-50" : ""}`}
      /> */}

      {/* Sales Executive Assignment */}
      {/* {(lead.status === 'assigned' || isAssignedToSales) && !isSalesExec && (
        <div className="bg-brand-blue/5 p-4 rounded-xl border border-brand-blue/10 animate-in fade-in slide-in-from-top-2 duration-300">
          <FormSelect
            label="Assign Sales Executive"
            icon={<User size={12} className="text-brand-blue" />}
            value={currentAssignedId || ""}
            onChange={e => onAssignmentChange(e.target.value)}
            disabled={isAssignedToSales}
            placeholder="Select Sales Executive"
            options={salesExecs.map(u => ({ 
              value: u._id, 
              label: `${u.name} ${u.employeeId ? `(${u.employeeId})` : ""}` 
            }))}
            labelClassName="!text-brand-blue"
            inputClassName={`!border-brand-blue/20 !bg-white font-bold ${currentAssignedId ? "opacity-60 cursor-not-allowed bg-slate-50" : ""}`}
          />
        </div>
      )} */}

      {/* Project Manager Assignment */}
      {/* {isSuperAdmin && (
        <div className="bg-emerald-50/50 p-4 rounded-xl border border-emerald-100 animate-in fade-in slide-in-from-top-2 duration-300">
          <FormSelect
            label="Assign Project Manager"
            icon={<Activity size={12} className="text-emerald-600" />}
            value={currentPMId || ""}
            onChange={e => onPMChange(e.target.value)}
            disabled={isPMDisabled}
            placeholder="Select Project Manager"
            options={projectManagers.map(u => ({ 
              value: u._id, 
              label: `${u.name} ${u.employeeId ? `(${u.employeeId})` : ""}` 
            }))}
            labelClassName="!text-emerald-700"
            inputClassName={`!border-emerald-200 !bg-white font-bold ${isPMDisabled ? "opacity-60 cursor-not-allowed bg-slate-50" : ""}`}
          />
        </div>
      )} */}
    </div>
  );
};
